import React, {useState, useRef} from "react";
import "./styles.css";
import arrow from "../../img/right.png"
import zoomin from "../../img/arrowup.png"
import zoomout from "../../img/arrwodown.png"

export default function Windower({elements}) {
  const [col, setCol] = useState(100); // Prozent
  const [row, setRow] = useState(100);
  const [fonts, setFonts] = useState([[32, 32], [32, 32]]);
  const [elementsShown, setElementsShown] = useState([[0, null],[null, null]]);
  const dragging = useRef(null);

  const handleMouseDown = (type) => () => {
    dragging.current = type;
  };

  const handleMouseUp = () => {
    dragging.current = null;
  };

  const handleMouseMove = (e) => {
    if (!dragging.current) return;

    if (dragging.current === "col") {
      const percent = (e.clientX / window.innerWidth) * 100;
      setCol(Math.min(80, Math.max(20, percent))); // min/max
    }

    if (dragging.current === "row") {
      const percent = (e.clientY / window.innerHeight) * 100;
      setRow(Math.min(80, Math.max(20, percent)));
    }
  };

  function navigators(z, s){
    return <div className={"navigators-container"}>
      <div alt={"r"} src={zoomout} style={{height: 32, display: "inline-block", fontSize: 54}} onClick={() => setFonts(o => {
        if (o[z][s] > 2)
          o[z][s] -= 6;
        return [...o];
      })}>-</div>
      <img alt={"l"} src={arrow} style={{height: 32, transform: "rotate(180deg)"}}
           onClick={() => setElementsShown(o => {
             o[z][s] = (o[z][s] + (elements.length - 1)) % elements.length;
             return [...o];
           })}/>
      <img alt={"r"} src={arrow} style={{height: 32}} onClick={() => setElementsShown(o => {
        o[z][s] = (o[z][s] + 1) % elements.length;
        return [...o];
      })}/>
      <div alt={"r"} src={zoomin} style={{height: 32, display: "inline-block", fontSize: 54}} onClick={() => setFonts(o => {
        if (o[z][s] < 128)
          o[z][s] += 6;
        return [...o];
      })}>+</div>
    </div>;
  }

  return (
    <div
      className="grid-container"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {/* Pane A */}
      {<div className="pane pane-a" style={{gridColumn: `1 / 2`, gridRow: `1 / 2`, fontSize: fonts[0][0]}}>
        <div style={{overflow: "scroll"}}>
          <h1>{elements[elementsShown[0][0]]?.name?.replaceAll("_", " ")}</h1>
          {elements[elementsShown[0][0]]?.description}
        </div>
        {navigators(0, 0)}
      </div>}

      {/* Pane B */}
      {elementsShown[0][1] !== null&&
        <div className="pane pane-b" style={{gridColumn: `2 / 3`, gridRow: `1 / 2`, fontSize: fonts[0][1]}}>
          <h1>{elements[elementsShown[0][1]]?.name?.replaceAll("_", " ")}</h1>
          {elements[elementsShown[0][1]]?.description}
          {navigators(0, 1)}
        </div>}

      {/* Pane C */}
      {elementsShown[1][0] !== null &&
        <div className="pane pane-c" style={{gridColumn: `1 / 2`, gridRow: `2 / 3`, fontSize: fonts[1][0]}}>
          <h1>{elements[elementsShown[1][0]]?.name?.replaceAll("_", " ")}</h1>
          {elements[elementsShown[1][0]]?.description}
          {navigators(1, 0)}
        </div>}

      {/* Pane D */}
      {elementsShown[1][1] !== null &&
        <div className="pane pane-d" style={{gridColumn: `2 / 3`, gridRow: `2 / 3`, fontSize: fonts[1][1]}}>
          <h1>{elements[elementsShown[1][1]]?.name?.replaceAll("_", " ")}</h1>
          {elements[elementsShown[1][1]]?.description}
          {navigators(1, 1)}
        </div>}

      {/* Vertical Drag Bar */}
      {elementsShown[0][1] !== null && <div
        className="drag-col"
        style={{left: `${col}%`}}
        onMouseDown={handleMouseDown("col")}
      />}

      {/* Horizontal Drag Bar */}
      {elementsShown[1][0] !== null && <div
        className="drag-row"
        style={{top: `${row}%`}}
        onMouseDown={handleMouseDown("row")}
      />}

      <div style={{position: "absolute", right: 0}}>
        <img alt={"r"} src={arrow} style={{height: 32}} onClick={() => setElementsShown(o => {
          if(o[0][1] == null){
            o[0][1] = 0
            if(o[1][0] != null)
              o[1][1] = 0
            setCol(50);
          }
          else{
            o[0][1] = null;
            o[1][1] = null;
            setCol(100)
          }
          return [...o]
        })}/>
      </div>

      <div style={{position: "absolute", bottom: 0}}>
        <img alt={"r"} src={arrow} style={{height: 32, transform: "rotate(90deg)"}} onClick={() => setElementsShown(o => {
          if(o[1][0] == null){
            o[1][0] = 0
            if(o[0][1] != null)
              o[1][1] = 0
            setRow(50);
          }
          else{
            o[1][0] = null;
            o[1][1] = null;
            setRow(100)
          }
          return [...o]
        })}/>
      </div>

      {/* Update grid template */}
      <style>
        {`
          .grid-container {
            grid-template-columns: ${col}% ${100 - col}%;
            grid-template-rows: ${row}% ${100 - row}%;
          }
          .maincontent {
            height: 100vh
          }
        `}
      </style>
    </div>
  );
}
